import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "backdrop", "submenu"]

  connect() {
    // Ensure we have the menu and backdrop elements
    // If not specifically targeted, find them by ID
    if (!this.hasMenuTarget) {
      this.menuTarget = document.getElementById("mobile-menu")
    }
    if (!this.hasBackdropTarget) {
      this.backdropTarget = document.getElementById("mobile-backdrop")
    }
  }


  toggle() {
    if (this.menuTarget.classList.contains("translate-x-full")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("translate-x-full")
    this.backdropTarget.classList.remove("hidden")
    // Allow backdrop to fade in
    setTimeout(() => {
      this.backdropTarget.classList.add("bg-opacity-50")
      this.backdropTarget.classList.remove("bg-opacity-0")
    }, 10)
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.menuTarget.classList.add("translate-x-full")
    this.backdropTarget.classList.add("bg-opacity-0")
    this.backdropTarget.classList.remove("bg-opacity-50")
    // Fade out backdrop before hiding
    setTimeout(() => {
      this.backdropTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }, 300)
  }

  toggleSubmenu(event) {
    event.preventDefault()
    const button = event.currentTarget
    const submenu = button.nextElementSibling
    const icon = button.querySelector('svg')

    if (submenu) {
      const isHidden = submenu.classList.contains("hidden")

      if (isHidden) {
        // 展开动画
        submenu.classList.remove("hidden")
        submenu.style.overflow = "hidden"
        submenu.style.maxHeight = "0px"
        submenu.style.transition = "max-height 0.3s ease-out"

        // 强制浏览器重绘，然后展开
        setTimeout(() => {
          submenu.style.maxHeight = submenu.scrollHeight + "px"
        }, 10)

        // 动画结束后清理样式
        setTimeout(() => {
          submenu.style.maxHeight = ""
          submenu.style.overflow = ""
          submenu.style.transition = ""
        }, 310)
      } else {
        // 收起动画
        submenu.style.maxHeight = submenu.scrollHeight + "px"
        submenu.style.overflow = "hidden"
        submenu.style.transition = "max-height 0.3s ease-out"

        // 强制浏览器重绘，然后收起
        setTimeout(() => {
          submenu.style.maxHeight = "0px"
        }, 10)

        // 动画结束后添加 hidden 类
        setTimeout(() => {
          submenu.classList.add("hidden")
          submenu.style.maxHeight = ""
          submenu.style.overflow = ""
          submenu.style.transition = ""
        }, 310)
      }

      if (icon) {
        icon.classList.toggle("rotate-180")
      }
    }
  }
}
